var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremiumMiniBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 45.0631L9.93112 52L11.24 33.7875L0 19.8622L16.8778 15.5432L26 0L35.1222 15.5432L52 19.8622L40.76 33.7875L42.0689 52L26 45.0631Z",
    fill: "#FFCA33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumMiniBadge);
export default __webpack_public_path__ + "static/media/premium-mini-badge.2465792c0775c428ab5058cbe5889740.svg";
export { ForwardRef as ReactComponent };